import './pagy.min';

window.addEventListener('load', Pagy.init);
